// Regras da tela Connect. Mesmo comportamento da tela antiga (views/RelatorioVendas.js):
// quem pode orçar, solicitar, avaliar, estender prazo e prorrogar, e como cada curso é montado
// a partir das turmas que a API devolve. Só funções puras, sem tela.

export const ANO_INICIAL = 2025;
export const ANO_FINAL = 2030;
export const ANOS_TIMELINE = [2025, 2026, 2027, 2028, 2029, 2030];

export const VENDEDORES = [
  { id: 7, nome: 'Rogerio Pinheiro' },
  { id: 10, nome: 'Elcio' },
  { id: 9, nome: 'Silene' },
  { id: 14, nome: 'Sandra' },
  { id: 15, nome: 'Haroldo' },
  { id: 23, nome: 'Marco Aurelio Custodio' },
  { id: 82, nome: 'Emily' },
  { id: 26, nome: 'Nilton' },
  { id: null, nome: 'A definir' }
];

const VENDEDORES_PERMITIDOS = [7, 9, 14, 15, 23, 26, 82, 81];

export const CATEGORIAS = {
  'EM NEGOCIAÇÃO': { classe: 'neg', rotulo: 'Em negociação' },
  'FECHADOS': { classe: 'fec', rotulo: 'Fechado' },
  'PERDIDO': { classe: 'per', rotulo: 'Perdido' }
};

export function anoDe(anoForm) {
  return parseInt(String(anoForm).split('/')[0], 10);
}

export function semestreDe(anoForm) {
  return parseInt(String(anoForm).split('/')[1], 10) || 1;
}

function anoForm(item) {
  return String(item.ano || item.Ano_Form);
}

export function temNegocio(reg) {
  return !!reg && reg.idNegocioBitrix != null &&
    reg.idNegocioBitrix !== '' &&
    reg.idNegocioBitrix !== 'null' &&
    String(reg.idNegocioBitrix).trim() !== '' &&
    String(reg.idNegocioBitrix).trim() !== '0';
}

// Nome exibido. Vendedor fora da lista fixa mostra o nome gravado, se houver.
export function nomeVendedor(vendedorId, nomeGravado) {
  if (!vendedorId) return 'A definir';
  const vendedor = VENDEDORES.find(v => String(v.id) === String(vendedorId));
  if (vendedor) return vendedor.nome;
  return nomeGravado && String(nomeGravado).trim() !== '' ? nomeGravado : 'A definir';
}

// Nome do vendedor logado na lista fixa (usado na aba "Meus cursos")
export function nomeNaListaDeVendedores(usuarioId) {
  const vendedor = VENDEDORES.find(v => v.id != null && String(v.id) === String(usuarioId));
  return vendedor ? vendedor.nome : null;
}

export function podeSolicitarVinculacao(usuario) {
  if (!usuario) return false;
  const nivel = usuario.Nivel ? usuario.Nivel.toUpperCase() : '';
  const funcao = usuario.Funcao ? usuario.Funcao.toUpperCase() : '';
  if (nivel === 'RESTRITO' && funcao === 'VENDEDOR') return true;
  if (nivel === 'SENIOR' && funcao === 'ORCAMENTISTA') return true;
  return VENDEDORES_PERMITIDOS.includes(Number(usuario.id));
}

export function podeAprovarSolicitacoes(usuario) {
  if (!usuario) return false;
  const funcao = usuario.Funcao ? usuario.Funcao.toUpperCase() : '';
  if (funcao === 'ORCAMENTISTA') return true;
  return Number(usuario.id) === 81;
}

function ordenarAnoSemestre(a, b) {
  const anoA = anoDe(anoForm(a));
  const anoB = anoDe(anoForm(b));
  if (anoA !== anoB) return anoA - anoB;
  return semestreDe(anoForm(a)) - semestreDe(anoForm(b));
}

function maisRecentePrimeiro(a, b) {
  return -ordenarAnoSemestre(a, b);
}

/**
 * Monta os cursos a partir das linhas (turmas) da API, como a tela antiga:
 * - historicoCompleto: todas as turmas, uma por ano/semestre (prefere a que tem negócio)
 * - turmas: de 2025 em diante (uma por ano/semestre, a primeira que veio) mais as linhas
 *   vazias (_placeholder) dos semestres sem registro, de 2025/1 a 2030/2 ou só dos anos filtrados
 * - vendedor do curso: turma mais recente com negócio; senão, a mais recente com vendedor
 * - vinculado: o que o servidor calculou (grupo_vinculado); sem ele, o cálculo local antigo
 */
export function agruparCursos(linhas, anosFiltrados) {
  const grupos = new Map();
  const filtrandoAnos = anosFiltrados && anosFiltrados.length > 0;

  (linhas || []).forEach(item => {
    const chave = String(item.id_curso_inst);
    if (!grupos.has(chave)) {
      grupos.set(chave, {
        id: chave,
        id_representante: item.id_curso_inst,
        nomeintituicao: item.nomeintituicao,
        sigla_instituicao: item.sigla_instituicao,
        nomecurso: item.nomecurso,
        nomecidade: item.nomecidade,
        siglaestado: item.siglaestado,
        vinculadoServidor: undefined,
        linhas: [],
        historicoCompleto: [],
        turmas: []
      });
    }
    const grupo = grupos.get(chave);
    grupo.linhas.push(item);
    if (typeof item.grupo_vinculado === 'boolean') {
      grupo.vinculadoServidor = grupo.vinculadoServidor || item.grupo_vinculado;
    }
    // Vendedor do curso calculado no servidor com todas as turmas (os filtros escondem turmas)
    if ('vendedor_curso_id' in item && !grupo.vendedorServidor) {
      grupo.vendedorServidor = { vendedor_id: item.vendedor_curso_id, nome_vendedor: item.vendedor_curso_nome };
    }

    const turma = anoForm(item);
    const iHist = grupo.historicoCompleto.findIndex(e => anoForm(e) === turma);
    if (iHist === -1) {
      grupo.historicoCompleto.push(item);
    } else if (!temNegocio(grupo.historicoCompleto[iHist]) && temNegocio(item)) {
      grupo.historicoCompleto[iHist] = item;
    }

    const ano = anoDe(turma);
    if (!isNaN(ano) && ano >= ANO_INICIAL && !grupo.turmas.some(e => anoForm(e) === turma)) {
      grupo.turmas.push(item);
    }
  });

  const anoAtual = new Date().getFullYear();

  return Array.from(grupos.values()).map(grupo => {
    const base = grupo.turmas[0] || {};
    const existentes = new Set(grupo.turmas.map(anoForm));
    const vazias = [];
    const criarVazia = (chave) => ({
      ...base,
      _placeholder: true,
      Ano_Form: chave,
      ano: chave,
      ano_formatura: chave,
      CategoriaStatus: null,
      Status: null,
      idNegocioBitrix: null,
      range_end_date: null,
      data_inclusao_orcamento: null,
      vendedor_id: null,
      vendedor: null,
      vendedor_exibicao: null,
      nome_vendedor: null,
      grupo_vinculado: undefined,
      id_curso_inst: base.id_curso_inst || grupo.id_representante
    });
    if (filtrandoAnos) {
      anosFiltrados.forEach(chave => { if (!existentes.has(chave)) vazias.push(criarVazia(chave)); });
    } else {
      ANOS_TIMELINE.forEach(ano => [1, 2].forEach(sem => {
        const chave = `${ano}/${sem}`;
        if (!existentes.has(chave)) vazias.push(criarVazia(chave));
      }));
    }
    const turmas = grupo.turmas.concat(vazias).sort(ordenarAnoSemestre);
    const historicoCompleto = grupo.historicoCompleto.slice().sort(ordenarAnoSemestre);

    const temVendedorValido = (t) => t.vendedor_id != null && t.vendedor_id !== 'null' && String(t.vendedor_id).trim() !== '';
    const relevante = (t) => anoDe(anoForm(t)) >= ANO_INICIAL;
    // 1º o vendedor relacionado (Relacionar / liberação aprovada): turma livre mais recente, do
    //    ano atual em diante, com vendedor. Mesma regra da trava no servidor.
    // 2º o dono do negócio mais recente; 3º a turma mais recente com vendedor.
    const doRelacionado = historicoCompleto
      .filter(t => temVendedorValido(t) && String(t.vendedor_id) !== '0' && !temNegocio(t) && anoDe(anoForm(t)) >= anoAtual)
      .sort(maisRecentePrimeiro)[0];
    const doLead = historicoCompleto.filter(t => temVendedorValido(t) && relevante(t) && temNegocio(t)).sort(maisRecentePrimeiro)[0];
    const doVendedor = grupo.vendedorServidor ||
      doRelacionado || doLead || historicoCompleto.filter(t => temVendedorValido(t) && relevante(t)).sort(maisRecentePrimeiro)[0];

    // Reserva: cálculo local antigo, só se o servidor não mandou grupo_vinculado
    const comStatus = turmas.filter(t => t.Status || t.CategoriaStatus);
    const vinculadoLocal = comStatus.some(t => anoDe(anoForm(t)) >= anoAtual - 2) &&
      historicoCompleto.some(t => anoDe(anoForm(t)) >= anoAtual - 2 && (t.CategoriaStatus || temNegocio(t)));

    return {
      ...grupo,
      turmas,
      historicoCompleto,
      vendedor_id: doVendedor ? doVendedor.vendedor_id : undefined,
      nome_vendedor: doVendedor ? doVendedor.nome_vendedor : undefined,
      vinculado: typeof grupo.vinculadoServidor === 'boolean' ? grupo.vinculadoServidor : vinculadoLocal
    };
  });
}

// Timeline: por ano, as turmas (2025+) com status, cada uma com o seu semestre
export function timelineDoCurso(curso) {
  const porAno = {};
  curso.turmas.forEach(t => {
    if (!(t.Status || t.CategoriaStatus)) return;
    const turma = anoForm(t);
    const ano = anoDe(turma);
    const semestre = String(turma).split('/')[1];
    if (!porAno[ano]) porAno[ano] = [];
    porAno[ano].push({
      turma,
      semestre: semestre === '1' || semestre === '2' ? semestre : null,
      categoria: t.CategoriaStatus || null,
      status: t.CategoriaStatus || t.Status,
      vendedor: t.nome_vendedor,
      dataInclusao: t.data_inclusao_orcamento ? new Date(t.data_inclusao_orcamento).toLocaleDateString('pt-BR') : null
    });
  });
  return porAno;
}

// Turmas até 2024 com status (o antigo modal 📅), a partir das linhas como vieram da API
export function historicoAte2024(curso) {
  const unicos = [];
  curso.linhas.forEach(item => {
    const ano = anoDe(item.Ano_Form);
    const temStatus = (item.Status && String(item.Status).trim() !== '' && item.Status !== 'SEM STATUS') ||
      (item.CategoriaStatus && String(item.CategoriaStatus).trim() !== '' && item.CategoriaStatus !== 'SEM STATUS');
    if (!temStatus || isNaN(ano) || ano > 2024) return;
    const i = unicos.findIndex(e => String(e.Ano_Form) === String(item.Ano_Form));
    if (i === -1) unicos.push(item);
    else if (item.CategoriaStatus && (!unicos[i].CategoriaStatus || (item.vendedor_id && item.vendedor_id !== 'null'))) unicos[i] = item;
  });
  return unicos;
}

// Histórico até 2024, do mais recente para o mais antigo
export function historicoRecente(curso) {
  return historicoAte2024(curso).slice().sort(maisRecentePrimeiro);
}

// Negócio mais recente (2025+) do curso — o link do antigo "CONTATO OK"
export function negocioMaisRecente(curso) {
  return curso.turmas
    .filter(t => t.idNegocioBitrix && t.idNegocioBitrix !== '')
    .sort(maisRecentePrimeiro)[0] || null;
}

function mesmaTurma(s, idGrupo, turma) {
  const [ano, semestre] = String(turma).split('/');
  return String(s.id_grupo) === String(idGrupo) &&
    String(s.ano_atendimento) === ano &&
    String(s.semestre_atendimento) === semestre;
}

export function diasRestantes(prazoFim) {
  return Math.ceil((new Date(prazoFim) - new Date()) / (1000 * 60 * 60 * 24));
}

// Botão Orçar do curso (antiga coluna "Orçamento" da linha principal)
export function podeOrcar(curso, usuario, solicitacoes) {
  const vendedorRelacionado = curso.vendedor_id && String(curso.vendedor_id) === String(usuario.id);
  if (vendedorRelacionado) return true;
  const solicitacaoGrupo = (solicitacoes || []).find(s =>
    (s.status === 'aprovado' || s.status === 'em_negociacao') &&
    String(s.id_vendedor_solicitante) === String(usuario.id) &&
    (String(s.id_grupo) === String(curso.id_representante) || String(s.id_grupo) === String(curso.id))
  );
  if (solicitacaoGrupo && solicitacaoGrupo.status === 'aprovado') return true;
  // Sem vendedor, ou vendedor fora da lista fixa (a tela antiga mostrava "A definir"): curso livre
  const vendedorNaLista = curso.vendedor_id && VENDEDORES.some(v => v.id != null && String(v.id) === String(curso.vendedor_id));
  return !curso.vendedor_id || !vendedorNaLista;
}

// Endereço do Cadastrar lead preenchido (o antigo ORÇAR)
export function linkCadastro(curso) {
  const primeira = curso.turmas[0];
  if (!primeira) return '/cadastro';
  return `/cadastro?estado=${curso.siglaestado}&cidade=${primeira.cod_cidade}&instituicao=${primeira.cod_inst}&curso=${primeira.cod_curso}&semestre=${primeira.Ano_Form}`;
}

/**
 * Situação da turma para o usuário (antiga coluna "Solicitação"), na mesma ordem:
 * avaliar | prioridade | negociando | solicitado | analise | solicitar | prazo | prioridadeOutro | negOutro | nada
 */
export function estadoTurma(curso, turma, usuario, solicitacoes, permissao) {
  const lista = solicitacoes || [];
  const idGrupo = curso.id_representante || turma.id_curso_inst;
  const chave = String(turma.Ano_Form);
  const pendente = lista.find(s => s.status === 'pendente' && mesmaTurma(s, idGrupo, chave));
  const aprovada = lista.find(s => s.status === 'aprovado' && String(s.id_vendedor_solicitante) === String(usuario.id) && mesmaTurma(s, idGrupo, chave));
  const vencida = lista.find(s => s.status === 'vencido' && String(s.id_vendedor_solicitante) === String(usuario.id) && mesmaTurma(s, idGrupo, chave));
  const status = turma.CategoriaStatus;
  const bloqueado = status === 'EM NEGOCIAÇÃO' || status === 'FECHADOS';
  const podeAprovar = podeAprovarSolicitacoes(usuario);
  const podeSolicitar = podeSolicitarVinculacao(usuario);

  if (pendente && podeAprovar && permissao !== 'ver') return { tipo: 'avaliar', solicitacao: pendente };

  if (turma.vendedor_id && String(turma.vendedor_id) === String(usuario.id)) {
    if (status === 'FECHADOS') return { tipo: 'prioridade' };
    if (status === 'EM NEGOCIAÇÃO') return { tipo: 'negociando' };
    return { tipo: 'nada' };
  }

  if (pendente) {
    return { tipo: String(pendente.id_vendedor_solicitante) === String(usuario.id) ? 'solicitado' : 'analise', solicitacao: pendente };
  }

  if (aprovada) {
    const dias = diasRestantes(aprovada.prazo_fim);
    if (dias < 0 && podeSolicitar && !bloqueado) return { tipo: 'solicitar' };
    return { tipo: 'prazo', solicitacao: aprovada, dias, podeProrrogar: dias <= 2 && !aprovada.prorrogacao_usada };
  }

  if (vencida && podeSolicitar && !bloqueado) return { tipo: 'solicitar' };
  if (status === 'FECHADOS') return { tipo: 'prioridadeOutro' };
  if (status === 'EM NEGOCIAÇÃO') return { tipo: 'negOutro' };
  if (podeSolicitar && !bloqueado) return { tipo: 'solicitar' };
  return { tipo: 'nada' };
}

// Selo "SOLICITADO" da turma (antigo Status Range da linha da turma)
export function temSolicitacaoAprovada(curso, turma, solicitacoes) {
  const [ano, semestre] = String(turma.ano || turma.Ano_Form).split('/');
  return (solicitacoes || []).some(s =>
    s.status === 'aprovado' &&
    String(s.id_grupo) === String(turma.id_curso_inst_representante || turma.id_curso_inst || curso.id) &&
    String(s.ano_atendimento) === ano &&
    (!s.semestre_atendimento || String(s.semestre_atendimento) === semestre)
  );
}

/**
 * Prazo de contato da turma (antiga coluna "Range"): 120 dias antes de 1º de janeiro do ano
 * da turma, ou a data estendida. Fechado = Concluído.
 */
export function prazoContato(turma) {
  const hoje = new Date();
  hoje.setHours(0, 0, 0, 0);
  const anoTurma = anoDe(turma.Ano_Form);
  if (isNaN(anoTurma)) return null;

  const padrao = new Date(anoTurma, 0, 1);
  padrao.setDate(padrao.getDate() - 120);
  let data = padrao;
  if (turma.range_end_date) {
    const gravada = new Date(turma.range_end_date);
    const valorAntigo = gravada.getUTCMonth() === 11 && gravada.getUTCDate() === 31 && gravada.getUTCFullYear() === anoTurma;
    if (!valorAntigo) data = gravada;
  }
  const dias = Math.ceil((data - hoje) / (1000 * 60 * 60 * 24));
  const texto = new Date(data).toLocaleDateString('pt-BR', { timeZone: 'UTC' });

  if (turma.CategoriaStatus === 'FECHADOS') return { texto, dias, situacao: 'concluido', rotulo: 'Concluído' };
  if (dias < 0) return { texto, dias, situacao: 'vencido', rotulo: 'Vencido' };
  return { texto, dias, situacao: dias < 30 ? 'perto' : 'ok', rotulo: `${dias} dias` };
}

// Botão +60d (só turma com registro, não fechada, do vendedor ou com liberação aprovada dele)
export function podeEstenderPrazo(turma, usuario, solicitacoes) {
  if (turma._placeholder || turma.CategoriaStatus === 'FECHADOS') return false;
  const vendedorRelacionado = turma.vendedor_id && String(turma.vendedor_id) === String(usuario.id);
  if (vendedorRelacionado) return true;
  const [ano, semestre] = String(turma.Ano_Form).split('/');
  return (solicitacoes || []).some(s =>
    s.status === 'aprovado' &&
    String(s.id_grupo) === String(turma.id_curso_inst_representante || turma.id_representante) &&
    String(s.id_vendedor_solicitante) === String(usuario.id) &&
    String(s.ano_atendimento) === ano &&
    String(s.semestre_atendimento) === semestre
  );
}

// Relacionar grava só no "atual": turmas livres que existem no banco, do ano atual em diante.
// Turma com negócio e turma passada são histórico e mantêm o vendedor delas.
export function turmasLivresParaRelacionar(curso) {
  const anoAtual = new Date().getFullYear();
  return curso.historicoCompleto.filter(t =>
    anoDe(anoForm(t)) >= anoAtual && !t.Status && !t.CategoriaStatus && !temNegocio(t)
  );
}

/**
 * Ação principal do curso na tabela. Não cria regra: escolhe, entre o que a tela antiga
 * já permitia, o que mostrar primeiro.
 */
export function acaoPrincipal(curso, usuario, solicitacoes, permissao) {
  const lista = solicitacoes || [];
  const doCurso = lista.filter(s => String(s.id_grupo) === String(curso.id));
  const pendentes = doCurso.filter(s => s.status === 'pendente');

  if (pendentes.length && podeAprovarSolicitacoes(usuario) && permissao !== 'ver') {
    return { tipo: 'avaliar', solicitacao: pendentes[0] };
  }
  if (podeOrcar(curso, usuario, lista)) {
    const minhaAprovada = doCurso.find(s => s.status === 'aprovado' && String(s.id_vendedor_solicitante) === String(usuario.id));
    return { tipo: 'orcar', prioridade: minhaAprovada ? diasRestantes(minhaAprovada.prazo_fim) : null };
  }
  if (pendentes.some(s => String(s.id_vendedor_solicitante) === String(usuario.id))) return { tipo: 'solicitado' };
  const turmaParaSolicitar = curso.turmas.find(t => estadoTurma(curso, t, usuario, lista, permissao).tipo === 'solicitar');
  if (turmaParaSolicitar) return { tipo: 'solicitar' };
  if (pendentes.length) return { tipo: 'analise' };
  return { tipo: 'com', vendedor: nomeVendedor(curso.vendedor_id, curso.nome_vendedor) };
}

export function turmasParaSolicitar(curso, usuario, solicitacoes, permissao) {
  return curso.turmas.filter(t => estadoTurma(curso, t, usuario, solicitacoes, permissao).tipo === 'solicitar');
}
